import fetch from 'common/js/fetch';

// 加载七牛token
export function getQiniuToken() {
  return fetch('/v1/common/get_qiniu_token');
}

// 获取阿里token
export function getAlToken() {
  return fetch('/core/v1/common/public/get_ali_token');
}
